import { getItem, setItem } from '../utils/storage'
import { normalizeRevenueCatId } from './revenuecat-ownership'

const REVENUECAT_MIXPANEL_SYNC_KEY_PREFIX = 'revenuecat.mixpanelDistinctId'

export function isRevenueCatMixpanelDistinctIdImmutableError(
  error: unknown,
): boolean {
  const message =
    typeof error === 'string'
      ? error
      : error instanceof Error
        ? error.message
        : typeof error === 'object' &&
            error != null &&
            'message' in error &&
            typeof error.message === 'string'
          ? error.message
          : null

  return (
    message
      ?.toLowerCase()
      .includes('mixpanel distinct id cannot be modified') ?? false
  )
}

function buildRevenueCatMixpanelSyncKey(revenueCatId: string): string {
  return `${REVENUECAT_MIXPANEL_SYNC_KEY_PREFIX}:${revenueCatId}`
}

export async function getStoredRevenueCatMixpanelDistinctId(
  revenueCatId: string,
): Promise<string | null> {
  const storedValue = await getItem(
    buildRevenueCatMixpanelSyncKey(revenueCatId),
    {
      scoped: false,
    },
  )

  return normalizeRevenueCatId(storedValue)
}

export async function markRevenueCatMixpanelDistinctIdSynced({
  revenueCatId,
  mixpanelId,
}: {
  revenueCatId: string
  mixpanelId: string
}): Promise<void> {
  await setItem(buildRevenueCatMixpanelSyncKey(revenueCatId), mixpanelId, {
    scoped: false,
  })
}
